import { Box } from '@base-app';
import { styled } from '@/stitches.config';
import { CSS } from '@stitches/react';

export const infoCardStyles: CSS = {
  display: 'flex',
  flexDirection: 'column'
};

export const StyledLoaderContainer = styled(Box, {
  margin: '88px 0',
});
